import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PayRun } from '../payrun.model';
import { RootState } from 'store/reducers';
import { PayRunNavigationSource } from '../constants';

interface PayPeriodState {
  currentPayPeriodIndex: number;
  navigationSource: PayRunNavigationSource;
  payPeriodsList: PayRun[];
  isLoadingPayPeriods: boolean;
}

const initialState: PayPeriodState = {
  currentPayPeriodIndex: -1,
  navigationSource: null,
  payPeriodsList: [],
  isLoadingPayPeriods: false
};

export const payPeriodSlice = createSlice({
  name: 'payPeriod',
  initialState,
  reducers: {
    setPayPeriodsList: (state, { payload }: PayloadAction<PayRun[]>) => {
      state.payPeriodsList = payload;
    },

    setCurrentPayPeriodIndex: (state, { payload }: PayloadAction<number>) => {
      state.currentPayPeriodIndex = payload;
    },

    setNavigationSource: (state, { payload }: PayloadAction<PayRunNavigationSource>) => {
      state.navigationSource = payload;
    },

    navigateToNextPayPeriod: state => {
      if (state.currentPayPeriodIndex < state.payPeriodsList.length - 1) {
        state.currentPayPeriodIndex += 1;
      }
    },

    navigateToPreviousPayPeriod: state => {
      if (state.currentPayPeriodIndex > 0) {
        state.currentPayPeriodIndex -= 1;
      }
    },

    resetPayPeriodNavigation: state => {
      state.currentPayPeriodIndex = -1;
      state.navigationSource = null;
      state.payPeriodsList = [];
    }
  }
});

export const {
  setPayPeriodsList,
  setCurrentPayPeriodIndex,
  setNavigationSource,
  navigateToNextPayPeriod,
  navigateToPreviousPayPeriod,
  resetPayPeriodNavigation
} = payPeriodSlice.actions;

export const selectCurrentPayPeriod = (state: RootState) =>
  state.rootReducer.payPeriod.payPeriodsList[state.rootReducer.payPeriod.currentPayPeriodIndex];

export const selectPayPeriodsList = (state: RootState) => state.rootReducer.payPeriod.payPeriodsList;

export const selectHasNextPayPeriod = (state: RootState) =>
  state.rootReducer.payPeriod.currentPayPeriodIndex < state.rootReducer.payPeriod.payPeriodsList.length - 1;

export const selectHasPreviousPayPeriod = (state: RootState) => state.rootReducer.payPeriod.currentPayPeriodIndex > 0;

export const selectCurrentPayPeriodIndex = (state: RootState) => state.rootReducer.payPeriod.currentPayPeriodIndex;

export const selectNavigationSource = (state: RootState) => state.rootReducer.payPeriod.navigationSource;

export default payPeriodSlice.reducer;
